import { is, List } from "immutable";
import _ from "lodash";
import * as moment from "moment";
import * as React from "react";
import * as BS from "react-bootstrap";
import { connect } from "react-redux";
import { Link, RouteComponentProps, withRouter } from "react-router-dom";
import * as redux from "redux";
import { InvitationSummary } from "./components";
import * as Actions from "../../../actions";
import * as Comp from "../../../components";
import { Paths } from "../../../constants";
import * as M from "../../../models";
import { Api } from "../../../services/Api";
import { AppState } from "../../../store";
import { AuthHelper, ReactHelper, Utility } from "../../../utils";

interface EventSelectedState { [index: number ]: number; }

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...Comp.Base.DefaultStatePropsMap(state, ownProps),
    abstracts: state.abstract.userAbstracts,
    events: state.abstract.events,
    loadingAbstracts: state.abstract.loadingUserAbstracts,
    subscribedUserAbstracts: state.abstract.subscribedUserAbstracts,
    userId: AuthHelper.tokenData(state.auth).userId || 0,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...Comp.Base.DefaultDispatchPropsMap(dispatch),
    loadAbstracts: (userId: number) => dispatch(Actions.Abstract.loadUserAbstracts(userId)),
    loadEvents: () => dispatch(Actions.Abstract.loadEvents()),
    removeAbstract: (abstract: M.Abstract.Abstract) => dispatch(Actions.Abstract.removeUserAbstract(abstract)),
    subscribeToUserAbstracts: (userId: number) => dispatch(Actions.Abstract.subscribeToUserAbstracts(userId)),
    toggleLoadingAbstracts: (loading: boolean) => dispatch(Actions.Abstract.toggleLoadingUserAbstracts(loading)),
    updateAbstract: (abstract: M.Abstract.Abstract) => dispatch(Actions.Abstract.updateUserAbstract(abstract)),
});

type OwnProps = RouteComponentProps<{}> & {
};

type ConnectedState = Comp.Base.DefaultConnectedState & {
    abstracts: List<M.Abstract.Abstract>;
    events: List<M.Event.Event>;
    loadingAbstracts: boolean;
    subscribedUserAbstracts: M.Generic.ResourceUpdated;
    userId: number;
};

type ConnectedDispatch = Comp.Base.DefaultConnectedDispatch & {
    loadAbstracts: (userId: number) => void;
    loadEvents: () => void;
    removeAbstract: (abstract: M.Abstract.Abstract) => void;
    subscribeToUserAbstracts: (userId: number) => void;
    toggleLoadingAbstracts: (loading: boolean) => void;
    updateAbstract: (abstract: M.Abstract.Abstract) => void;
};

interface OwnState {
    checkingFinancialDisclosure: boolean;
    checkingMemberDuesAmount: boolean;
    checkingMemberStatus: boolean;
    duesAmount?: M.Member.DuesAmount;
    hasFinancialDisclosure: boolean;
    memberIsActive?: boolean;
    selectedEvents: EventSelectedState;
    sendingFdRequest: M.Generic.ItemLoadingState;
}

type CombinedProps = ConnectedState & ConnectedDispatch & OwnProps;

class AbstractsComponent extends Comp.Base.BaseComponent<CombinedProps, OwnState> {

    private _confirmDelete: Comp.Modal.ConfirmModal | null = null;

    public constructor(props: any) {
        super(props);
        this.state = {
            checkingFinancialDisclosure: true,
            checkingMemberDuesAmount: true,
            checkingMemberStatus: true,
            hasFinancialDisclosure: false,
            selectedEvents: {},
            sendingFdRequest: {},
        };
    }

    public componentDidMount() {
        this._isMounted = true;

        if (this.props.abstracts.size === 0)
            this.props.toggleLoadingAbstracts(true);

        this.loadData();
        this.props.subscribeToUserAbstracts(this.props.userId);
    }

    public componentDidUpdate(prevProps: Readonly<CombinedProps>) {
        if (!is(prevProps.websocket, this.props.websocket))
            this.props.subscribeToUserAbstracts(this.props.userId);

        if (!is(prevProps.subscribedUserAbstracts[this.props.userId], this.props.subscribedUserAbstracts[this.props.userId]))
            this.loadData();
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public render() {

        const duesAmount = (this.state.duesAmount && this.state.duesAmount.amount) || 0;
        const memberIsActive = this.state.memberIsActive !== undefined && this.state.memberIsActive;

        const distinctEventTypes = this.props.events
            .map((e: M.Event.Event) => ({ id: e.typeId, name: e.type }))
            .groupBy((e: M.Event.EventType) => e.id)
            .toList();

        const eventListDisplay = distinctEventTypes.map((iterableET, i) => {
            if (iterableET) {
                const eventType = iterableET.first() as M.Event.EventType;
                const events = this.props.events
                    .filter((e: M.Event.Event) => e.typeId === eventType.id)
                    .sortBy((e: M.Event.Event) => Utility.utcToValue(e.startDate))
                    .reverse();

                // get selected event ID
                let selectedEventId = this.state.selectedEvents[eventType.id];
                if (selectedEventId === undefined && events.size)
                    selectedEventId = events.first().id;

                let selectedEvent: M.Event.Event | undefined;
                if (selectedEventId > 0)
                    selectedEvent = this.props.events.find((e: M.Event.Event) => e.id === selectedEventId);

                const submitAbstractBtn = selectedEvent
                        && selectedEvent.abstractSettings
                        && M.Abstract.isSubmissionsOpen(selectedEvent.abstractSettings)
                        // && duesAmount >= 0
                        && !this.state.checkingMemberStatus
                        // && memberIsActive
                    ? <Link to={Paths.AbstractsComposeNew(selectedEvent.id)}>Submit an abstract &raquo;</Link>
                    : null;

                // Create abstract list for the selected event of each event type
                const abstracts = this.props.abstracts.filter((a: M.Abstract.Abstract) => a.eventId === selectedEventId);

                const invitationAbstracts = abstracts.filter((a: M.Abstract.Abstract) => M.Abstract.isAllowedForInvitationResponse(a)).toList();
                const invitationSummary = invitationAbstracts.size && selectedEvent
                    ? <InvitationSummary
                        abstracts={invitationAbstracts}
                        api={this.props.api}
                        event={selectedEvent}
                        onResponseUpdated={(a, invitationResponseId) => this.onInvitationResponseUpdated(a.id, invitationResponseId)}
                        onUpdateFailed={(a, errors) =>
                            this.props.notifyError(
                                `Failed to save your invitation response for abstract<br /><strong>${a.title}</strong><br />`
                                    + errors.join("<br />"))
                        }
                    />
                    : null;

                const abstractList = abstracts.size
                    ? <ul className="abstracts">
                        {abstracts.map((a: M.Abstract.Abstract, j) => {
                            let status = _.find(M.Abstract.AbstractStatuses.Values, (v) => v.id === a.statusId);

                            // if the abstract is Accepted, but the invitation emails were not sent out yet,
                            // display a status of Complete.
                            if (a.statusId === M.Abstract.AbstractStatuses.Accepted.id && !a.invitationSent)
                                status = M.Abstract.AbstractStatuses.Complete;

                            const isSubmitted = M.Abstract.AbstractStatuses.isSubmitted(a);
                            const isSubmitDeadlinePassed = M.Abstract.isSubmitDeadlinePassed(a.submitDeadline || "");
                            const notSubmittedMsg = !isSubmitted && !isSubmitDeadlinePassed
                                ? <p className="mute">
                                    Deadline {M.Abstract.deadlineDisplay(a.submitDeadline || "").format("MMM D, YYYY")}.{" "}
                                    <Link to={Paths.AbstractsCompose(a.eventId, "review", a.guid)}>Review and submit &raquo;</Link>
                                </p>
                                : null;

                            const deleteBtn = !isSubmitted
                                ? <p><a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.toggleDeleteConfirmation(a); }}>Delete</a></p>
                                : null;

                            let disclosuresNeeded: JSX.Element | null = null;
                            const authorsWithoutFDs = a.authors.filter((x) => !x.isPrimary && !x.hasFd);
                            if (isSubmitted && authorsWithoutFDs.length > 0) {
                                disclosuresNeeded = <p key={0} className="mute">{authorsWithoutFDs.map((x, k) => {
                                    const isSendingFdReq = !!this.state.sendingFdRequest[x.id];
                                    return <Comp.Generic.WrapperLess key={k}>
                                        {k === 0 ? null : <br />}Disclosure required: {M.Generic.PersonHelper.getFullName(x)}

                                        {x.lastFdRequestSent
                                            ? <Comp.Generic.WrapperLess>
                                                &nbsp;&nbsp;&nbsp;
                                                Request sent {moment(Utility.utcToLocal(x.lastFdRequestSent)).format("MMM D, YYYY")}
                                            </Comp.Generic.WrapperLess>
                                            : null}

                                        &nbsp;&nbsp;&nbsp;
                                        {isSendingFdReq
                                            ? <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); }}>
                                                <Comp.Generic.LoadingIcon /> Resending disclosure request&hellip;
                                            </a>
                                            : <a href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.sendFdRequest(a.guid, x.id); }}>
                                                Resend disclosure request &raquo;
                                            </a>
                                        }
                                    </Comp.Generic.WrapperLess>;
                                })}</p>;
                            }

                            const abstractLink = !isSubmitted && !isSubmitDeadlinePassed
                                ? Paths.AbstractsCompose(a.eventId, "review", a.guid)
                                : Paths.UserAbstractDetails(a.guid);

                            return <li key={j}>
                                <p>
                                    <Link to={abstractLink} dangerouslySetInnerHTML={{ __html: a.title }} />
                                    <br />
                                    <span className="mute">
                                        {a.typeShortName}, Created {moment(Utility.utcToLocal(a.createdOn)).format("MMM D, YYYY")}
                                    </span>
                                </p>
                                <p><strong>{status ? status.name : "Unknown status"}</strong></p>
                                {notSubmittedMsg}
                                {disclosuresNeeded}
                                {deleteBtn}
                            </li>;
                        })}
                    </ul>
                    : <p>No abstracts have been submitted yet.</p>;

                return <Comp.Generic.WrapperLess key={i}>
                    <h2>{eventType.name}</h2>

                    <p>
                        <select className="txt-natural" value={selectedEventId} onChange={(e) => this.onEventChange(eventType.id, parseInt(e.target.value, 10))}>
                            {events.map((e: M.Event.Event, j) => (
                                <option key={j} value={e.id}>{e.title}</option>
                            ))}
                        </select>
                        {submitAbstractBtn}
                        &nbsp;&nbsp;&nbsp;
                        <a href={Paths.Legacy.AbstractsArchive}>View older abstracts &raquo;</a>
                    </p>

                    {invitationSummary}

                    {abstractList}
                </Comp.Generic.WrapperLess>;
            }
            return null;
        });

        return <Comp.Page.PublicPage additionalClasses="full" pageTitle="Your Abstracts">
            <Comp.Modal.ConfirmModal
                headerClassName="warning"
                onProceed={() => this.handleAbstractDelete()}
                title="Delete abstract"
                ref={(ref) => this._confirmDelete = ref}
            >
                <p>Are you sure you want to delete this abstract?</p>
            </Comp.Modal.ConfirmModal>

            <Comp.Layout.ContentPrimary>

                {this.getErrorAlert()}

                <h1>Your Abstracts</h1>

                <BS.Collapse in={!this.state.checkingFinancialDisclosure && !this.state.hasFinancialDisclosure}>
                    <BS.Alert bsStyle="info">
                        <h3>
                            <Link to={Paths.User.FinancialDisclosureUpdate}>
                                <Comp.Generic.Icon icon="info-circle" /> Please update your financial disclosure
                            </Link>
                        </h3>
                        <p>
                            An abstract will not be considered complete and eligible for
                            consideration until all financial disclosures are on record.
                        </p>
                    </BS.Alert>
                </BS.Collapse>

                <BS.Collapse in={duesAmount < 0}>
                    <BS.Alert bsStyle="info">
                        <h3><Comp.Generic.Icon icon="info-circle" /> Please renew your membership</h3>
                        <p>
                            You have an unpaid account balance of ${Utility.formatThousands(-duesAmount)}.{" "}
                            To submit an abstract as a member please <a href={Paths.Legacy.MakePayment}>renew your membership</a>.
                        </p>
                    </BS.Alert>
                </BS.Collapse>

                <BS.Collapse in={!this.state.checkingMemberStatus && !memberIsActive}>
                    <BS.Alert bsStyle="info">
                        <h3><Comp.Generic.Icon icon="info-circle" /> Your membership is inactive</h3>
                        <p>
                            Our records indicate that your membership status is inactive.
                        </p>
                    </BS.Alert>
                </BS.Collapse>

                <div style={{ minHeight: "150px", position: "relative" }}>
                    <Comp.Generic.LoadingSpinner show={this.props.loadingAbstracts} />

                    {eventListDisplay}
                </div>
            </Comp.Layout.ContentPrimary>
        </Comp.Page.PublicPage>;
    }

    private async handleAbstractDelete() {
        if (this._confirmDelete === null)
            return;

        const abstract = this._confirmDelete.getRef() as M.Abstract.Abstract;
        if (abstract !== undefined) {
            const result = await this.props.api.delete(Api.endpoints.abstract.abstract.withUrlParams({ guid: abstract.guid }));
            if (result.isSuccess) {
                this.props.removeAbstract(abstract);
                this.props.notifySuccess("Abstract has been successfully deleted.");
            }
            else {
                this.props.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />"));
            }

            if (this._confirmDelete)
                this._confirmDelete.close();
        }
    }

    private loadData() {
        this.props.loadAbstracts(this.props.userId);
        this.props.loadEvents();
        this.loadFinancialDisclosure();
        this.loadMemberDuesAmount();
        this.loadMemberStatus();
    }

    private async loadFinancialDisclosure() {
        const result = await this.props.api.get(Api.endpoints.users.financialDisclosure.get);
        if (result.isSuccess && this._isMounted) {
            this.setState({
                ...this.state,
                checkingFinancialDisclosure: false,
                hasFinancialDisclosure: result.data !== null,
            });
        }
    }

    private async loadMemberDuesAmount() {
        const result = await M.Member.MemberHelper.getAmountDue(this.props.api, this.props.userId);
        if (result.isSuccess && this._isMounted) {
            this.setState({
                ...this.state,
                checkingMemberDuesAmount: false,
                duesAmount: result.data,
            });
        }
    }

    private async loadMemberStatus() {
        const memberIsActive = await M.Abstract.memberStatusIsAllowed(this.props.api, this.props.userId);
        this.setState({
            ...this.state,
            checkingMemberStatus: false,
            memberIsActive,
        });
    }

    private onEventChange(eventTypeId: number, eventId: number) {
        const selectedEvents = {...this.state.selectedEvents};
        selectedEvents[eventTypeId] = eventId;
        this.setState({ ...this.state, selectedEvents });
    }

    private onInvitationResponseUpdated(abstractId: number, invitationResponseId: number) {
        const a = this.props.abstracts.find((x) => x !== undefined && x.id === abstractId);
        if (a) {
            a.invitationResponseId = invitationResponseId;
            this.props.updateAbstract(a);
            this.props.notifySuccess("Your invitation response has been successfully saved.");
        }
    }

    private async sendFdRequest(guid: string, authorId: number) {
        let sendingFdRequest = { ...this.state.sendingFdRequest };

        sendingFdRequest[authorId] = true;
        this.setState({ ...this.state, sendingFdRequest });

        const result = await this.props.api.get(Api.endpoints.abstract.sendFdRequest.withUrlParams({ guid, authorId }));
        if (!this._isMounted)
            return;

        if (result.isSuccess && result.data) {
            const abstract = this.props.abstracts.find((x: M.Abstract.Abstract) => x.guid === guid);
            console.log("abstract found?", abstract);
            if (abstract) {
                const author = _.find(abstract.authors, (x) => x.id === authorId);
                console.log("author found?", author);
                if (author) {
                    author.lastFdRequestSent = result.data.lastFdRequestSent;
                    this.props.updateAbstract(abstract);
                }
            }

            this.props.notifySuccess(`Financial disclosure request has been successfully sent to <strong>${M.Generic.PersonHelper.getFullName(result.data)}</strong>`);
        }
        else {
            this.props.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />"));
        }

        sendingFdRequest = { ...this.state.sendingFdRequest };
        sendingFdRequest[authorId] = false;
        this.setState({ ...this.state, sendingFdRequest });
    }

    private toggleDeleteConfirmation(abstract: M.Abstract.Abstract) {
        if (this._confirmDelete !== null)
            this._confirmDelete.show(abstract);
    }
}

export const Abstracts: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(withRouter(AbstractsComponent) as any);



// WEBPACK FOOTER //
// ./src/containers/user/abstracts/Abstracts.tsx